import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

/** Small caption when chart data was grouped/truncated for readability. */
export default function DashboardGroupedChartHint({ shown, total, sx }) {
  const { t } = useTranslation("settings");
  if (!total || !shown || shown >= total) return null;

  return (
    <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1, ...sx }}>
      {t("dashboardPage.shared.chartGroupedHint", {
        shown,
        total,
        defaultValue: `Exibindo os ${shown} principais de ${total} categorias. As demais foram agrupadas em "Outros".`,
      })}
    </Typography>
  );
}
